import(/* webpackMode: "eager" */ "/home/runner/work/snep-land/snep-land/Components/Navigation/Navigation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Analytics"] */ "/home/runner/work/snep-land/snep-land/node_modules/@vercel/analytics/dist/react/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["SpeedInsights"] */ "/home/runner/work/snep-land/snep-land/node_modules/@vercel/speed-insights/dist/next/index.mjs");
;
import(/* webpackMode: "eager" */ "/home/runner/work/snep-land/snep-land/style/global.css");
;
import(/* webpackMode: "eager" */ "/home/runner/work/snep-land/snep-land/Components/Body/style.module.css");
